export default {
  INVALID_NUMBER: 'It looks like the number you dialled is invalid. Check the number and try again.',
};
